import { registerAppNamespace } from '@aaas/shared';

import enCalendar from './locales/en/ats/calendar.json';
import enCampaign from './locales/en/ats/campaign.json';
import enCommon from './locales/en/ats/common.json';
import enConfig from './locales/en/ats/config.json';
import enCv from './locales/en/ats/cv.json';
import enEmail from './locales/en/ats/email.json';
import enJd from './locales/en/ats/jd.json';
import enJob from './locales/en/ats/job.json';
import enMatching from './locales/en/ats/matching.json';
import enNav from './locales/en/ats/nav.json';
import enOnboarding from './locales/en/ats/onboarding.json';
import enPipeline from './locales/en/ats/pipeline.json';
import enPool from './locales/en/ats/pool.json';
import enPublic from './locales/en/ats/public.json';
import viCalendar from './locales/vi/ats/calendar.json';
import viCampaign from './locales/vi/ats/campaign.json';
import viCommon from './locales/vi/ats/common.json';
import viConfig from './locales/vi/ats/config.json';
import viCv from './locales/vi/ats/cv.json';
import viEmail from './locales/vi/ats/email.json';
import viJd from './locales/vi/ats/jd.json';
import viJob from './locales/vi/ats/job.json';
import viMatching from './locales/vi/ats/matching.json';
import viNav from './locales/vi/ats/nav.json';
import viOnboarding from './locales/vi/ats/onboarding.json';
import viPipeline from './locales/vi/ats/pipeline.json';
import viPool from './locales/vi/ats/pool.json';
import viPublic from './locales/vi/ats/public.json';

const enAts = {
  ...enNav,
  ...enCommon,
  ...enCv,
  ...enJob,
  ...enJd,
  ...enPool,
  ...enPipeline,
  ...enCampaign,
  ...enEmail,
  ...enCalendar,
  ...enMatching,
  ...enConfig,
  ...enPublic,
  ...enOnboarding,
};

const viAts = {
  ...viNav,
  ...viCommon,
  ...viCv,
  ...viJob,
  ...viJd,
  ...viPool,
  ...viPipeline,
  ...viCampaign,
  ...viEmail,
  ...viCalendar,
  ...viMatching,
  ...viConfig,
  ...viPublic,
  ...viOnboarding,
};

let registered = false;

export function registerAtsNamespace() {
  if (registered) return;
  registered = true;
  registerAppNamespace('ats', { en: enAts, vi: viAts });
}
